import type { StylableElementProps } from '@subaio/components'

import { BrandFlagSmall } from './BrandFlagSmall'
import { BrandLogo } from './BrandLogo'
import { BrandWrapper } from './BrandWrapper'
import defaultLogo from './defaultLogo.svg'

type Props = StylableElementProps & {
	brandId?: string
	size?: number
}

export const BrandSquare = ({ brandId, size = 28, className, style }: Props) => (
	<BrandWrapper size={size} className={className} style={style}>
		<BrandLogo brandId={brandId} size={size * 0.8} defaultImage={defaultLogo} />
		<BrandFlagSmall brandId={brandId} size={size * 0.5} />
	</BrandWrapper>
)
